var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.018,
    height: 10.017,
    viewBox: "0 0 10.018 10.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit-major-svgrepo-com",
    d: "M7.436.7l1.879,1.88.313-.314A1.329,1.329,0,1,0,7.749.39ZM8.453,3.444,6.573,1.564.61,7.528,0,10.017l2.489-.61Z",
    transform: "translate(0 -0.001)",
    fill: "#37e0eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.873f846c73909dd2af96067df64dd986.svg";
export { ForwardRef as ReactComponent };